import { render, staticRenderFns } from "./ConsultantsSelection.vue?vue&type=template&id=a0b24584&scoped=true"
import script from "./ConsultantsSelection.vue?vue&type=script&lang=js"
export * from "./ConsultantsSelection.vue?vue&type=script&lang=js"
import style0 from "./ConsultantsSelection.vue?vue&type=style&index=0&id=a0b24584&prod&lang=scss&scoped=true"
import style1 from "./ConsultantsSelection.vue?vue&type=style&index=1&id=a0b24584&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b24584",
  null
  
)

export default component.exports